import { css } from '../../styles/theme';

export const StylesOV = css``;
